<template>
  <FormLabel class="control-label" :for="field">{{title}}</FormLabel>
</template>
<script setup lang="ts">
import startCase from 'lodash/startCase'
import { computed } from 'vue'

const props = defineProps<{
  field?: string
  label?: string
}>()

const title = computed(() => {
  return props.label || startCase(props.field).replace('Custom ', '')
})
</script>
<style scoped>
.control-label {
  flex: 1;
  max-width: 150px;
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
}
</style>